import GenericError from 'components/Happening/GenericError/GenericError';
import { withGenericErrorProps } from 'viewModel/happening/withGenericErrorProps';

export default withGenericErrorProps(GenericError);
